<template>
  <div class="aside-bar-fixed" :class="[zsTjTheme]" :style="customStyle">
    <div class="aside-left">
      <img :src="detail.user.avatar" class="avatar" @click="goUserInfo" />
      <div class="title">
        <span class="name">{{ detail.user.username }}</span>
        <span class="update"
          >{{ dayjs(detail.updated_at * 1000).format("YYYY/MM/DD") }}更新，{{
            formatCount(detail.view_count)
          }}阅读量</span
        >
      </div>
    </div>
    <div class="aside-right">
      <div v-show="!commentVisible && detail.id" class="list">
        <div class="aside-item" @click="onShare" :title="$t('tj.zs.fx')">
          <SvgIcon class="icon" icon-class="zs-tj-share" />
          <span>分享</span>
        </div>
        <div class="divider"></div>
        <div class="aside-item" v-if="detail.id" @click="openComment" :title="$t('tj.zs.pl')">
          <SvgIcon class="icon" icon-class="zs-tj-comment" />
          <span>评论{{ formatCount(detail.comment_count) }}</span>
        </div>
        <div class="divider"></div>
        <div class="aside-item like-item" :title="$t('tj.zs.dz')">
          <SvgIcon
            class="icon"
            :style="{ color: detail.is_like ? 'rgb(254, 93, 93)' : null }"
            icon-class="zs-tj-like"
            @click.native="onLike"
          />
          <span class="like-it">赞同{{ formatCount(detail.like_count) }}</span>
          <div class="like-down">
            <SvgIcon
              class="icon"
              icon-class="zs-tj-like"
              :style="{ color: detail.is_unlike ? '377CC7' : null }"
              @click.native="handleUnlike"
            />
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :title="`评论（${detail.comment_count}）`"
      :visible.sync="commentVisible"
      append-to-body
      width="684px"
      :custom-class="`comment-dialog ${zsTjTheme}`"
      top="10vh"
    >
      <div class="dialog-comment-list">
        <div class="emoj-container">
          <!-- 帖子表情包 -->
          <DetailEmojiBar
            :detail="detail"
            @emojiCheck="onEmojiCheck"
            :is-dark="zsTjTheme === 'dark'"
            :class="[zsTjTheme]"
          />
        </div>
        <DetailComment
          :detail="contentDetail"
          :user="contentDetail.user"
          :list="commentList"
          :pagination="pagination"
          :loadCommentStatus="loadCommentStatus"
          @getCommentList="getCommentList"
          @refresh="refresh"
          @setLoading="setLoading"
        />
      </div>
      <div class="fllow-comment" :class="[zsTjTheme]">
        <div class="aside-item" @click="onLike">
          <i :class="['wiki-icon', detail.is_like ? 'wiki-icon-detail-like-active' : 'wiki-icon-detail-like']"></i>
          <span>{{ formatCount(detail.like_count) }}</span>
        </div>
        <div class="aside-item" @click="onFavorite">
          <i
            :class="[
              'wiki-icon',
              detail.is_favorite ? 'wiki-icon-detail-favorite-active' : 'wiki-icon-detail-favorite'
            ]"
          ></i>
          <span>{{ formatCount(detail.favorite_count) }}</span>
        </div>
        <div class="aside-item" @click="onShare">
          <i :class="['wiki-icon', 'wiki-icon-detail-share']"></i>
          <span>{{ $t("tj.zs.fx") }}</span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Clipboard from "clipboard";
import dayjs from "@/plugins/dayjs";
import calcMixin from "@/mixins/calcMixin";
import { mapGetters } from "vuex";
import DetailComment from "@/views/wiki/tj/zs/components/detailComment.vue";
import { apiCommentList } from "@/api/commentApi";
import DetailEmojiBar from "@/views/wiki/detail/components/detailEmojiBar.vue";
// api
import { apiContentLike, apiContentUnlike } from "@/api/contentApi";
import { apiUserAddFavorite } from "@/api/userApi";
// plugins
import { debounce, trackingPoint, toast } from "@/plugins/util";

export default {
  name: "asideBarFixed",
  mixins: [calcMixin],
  components: { DetailComment, DetailEmojiBar },
  props: {
    customStyle: {
      type: Object,
      default: () => ({})
    },
    detail: {
      type: Object,
      default: () => ({})
    },
    isDark: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      contentDetail: {},
      commentVisible: false,
      // 评论列表
      commentList: [],
      pagination: {
        limit: 10,
        page_no: 0,
        page_total: 1,
        total: 0
      },
      loadCommentStatus: ""
    };
  },
  computed: {
    ...mapGetters(["gameInfo", "zsTjTheme"])
  },
  watch: {
    detail: {
      handler(val) {
        this.contentDetail = val;
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    dayjs,
    goEdit() {
      this.$router.push(
        `/${this.gameInfo.alias}/rich-table?id=${this.detail.id}&entry_id=${this.detail.entry_id}&title=${this.detail.title}`
      );
    },
    handleScroll() {},
    handleUnlike() {
      if (this.detail.is_like === 1) {
        this.detail.like_count--;
      }
      const isUnlike = Boolean(this.detail.is_unlike);
      this.detail.is_like = 0;
      this.detail.is_unlike = isUnlike ? 0 : 1;
      const data = {
        origin_id: this.detail.id,
        type: 1
      };
      apiContentUnlike(data);
    },
    formatCount(count) {
      if (count >= 1000 && count < 10000) {
        return Math.floor(count / 1000) + "k+";
      } else if (count > 10000) {
        return Math.floor(count / 10000) + "w+";
      }
      return count;
    },
    openComment() {
      this.trackingPoint("Brown_character_web_review");
      this.commentVisible = true;
      this.getCommentList("refresh");
    },
    // 设置loading
    setLoading(loading) {
      this.loading = loading;
    },
    // 刷新详情
    refresh(detail, user) {
      if (detail) {
        this.$set(this, "contentDetail", detail);
      }
      if (user) {
        this.$set(this.contentDetail, "user", user);
      }
    },
    // 获取评论
    async getCommentList(type) {
      if (this.$route.params.id.includes("_")) return;
      if (type == "refresh") {
        this.pagination = {
          limit: 10,
          page_no: 0,
          page_total: 1,
          total: 0
        };
        this.commentList = [];
      }
      let { pagination } = this;
      if (pagination.page_no >= pagination.page_total) {
        this.loadCommentStatus = "end";
        return;
      }
      let { id } = this.$route.params;
      ++pagination.page_no;
      let params = {
        ...pagination,
        content_id: Number(id)
      };
      this.loadCommentStatus = "loading";
      await apiCommentList(params)
        .then(res => {
          if (res.code == 0) {
            this.commentList = this.commentList.concat(res.data);
            this.pagination = res.meta.pagination;
            // if (this.list.length > 2 && this.pagination.page_no == 1) {
            // }
          }
        })
        .finally(_ => {
          this.loadCommentStatus = "";
        });
    },
    trackingPoint,
    // 点赞
    onLike: debounce(function(value) {
      this.detail.is_unlike = 0;
      this.trackingPoint("Brown_character_web_like");
      let params = {
        is_like: this.detail.is_like ? 0 : 1,
        origin_id: this.detail.id,
        type: 1
      };
      params.is_like ? this.detail.like_count++ : this.detail.like_count--;
      this.detail.is_like = params.is_like;
      if (this.detail.like_count < 0) this.detail.like_count = 0;
      apiContentLike(params).then(res => {
        this.$emit("refresh", this.detail);
      });
    }),
    // 收藏文章
    onFavorite() {
      if (!this.isLoginShow()) return false;
      let params = {
        origin_id: this.detail.id,
        type: 1
      };
      apiUserAddFavorite(params).then(res => {
        if (res.code == 0) {
          this.detail.is_favorite = this.detail.is_favorite ? 0 : 1;
          this.detail.is_favorite ? this.detail.favorite_count++ : this.detail.favorite_count--;
          this.$emit("refresh", this.detail);
        }
      });
    },
    onShare() {
      // this.trackingPoint("Brown_character_web_sharing");
      // eventBus.$emit("openZSTJShare");
      let shareText = `${this.$store.state.userInfo.username || ""}分享了链接:\r\n`;
      shareText += window.location.href + "\r\n";
      shareText += "来自GameKee";
      let $div = document.createElement("div");
      $div.setAttribute("data-clipboard-text", shareText);
      $div.classList.add("page-share-copy-btn");
      document.body.appendChild($div);
      let clipboard = new Clipboard(".page-share-copy-btn");
      clipboard.on("success", e => {
        toast("复制成功！");
        document.body.removeChild($div);
        clipboard.destroy();
      });
      clipboard.on("error", e => {
        // 不支持复制
        toast("浏览器不支持自动复制,请更换其他浏览器");
        document.body.removeChild($div);
        clipboard.destroy();
      });
      $div.click();
    },
    /** 点击帖子底部某个表情也视为点赞 */
    onEmojiCheck() {
      if (this.detail.is_like === 0) {
        this.detail.like_count++;
      }
      this.detail.is_like = 1;
    },
    goUserInfo() {
      this.$router.push(`/user/index/${this.detail.uid}.html`);
    }
  }
};
</script>
<style lang="less" scoped>
.aside-bar-fixed {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 58px;
  padding: 0 10px;
  .aside-left {
    display: flex;
    column-gap: 10px;
    align-items: center;

    .avatar {
      width: 38px;
      height: 38px;
      border-radius: 4px;
      cursor: pointer;
    }

    .title {
      color: #dfdfdf;
      font-size: 14px;
      display: flex;
      column-gap: 20px;

      .name {
        font-size: 16px;
        color: rgba(223, 223, 223, 1);
      }
      .update {
        color: rgba(153, 153, 153, 1);
      }
    }
  }

  .aside-right {
    flex-grow: 1;
  }

  .list {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    column-gap: 20px;
    padding-right: 10px;
    .aside-item {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 6px;
      color: #a8b9bf;
      font-size: 12px;
      line-height: 12px;
      transition: all ease 0.3s;
      cursor: pointer;

      .icon {
        width: 20px;
        height: 20px;

        &.active {
          fill: rgb(254, 93, 93);
        }
      }

      .like-down {
        position: relative;
        //border-right: 1px solid rgba(255, 255, 255, 0.15);
        padding-right: 20px;
        transform: rotate(180deg);

        &:before {
          content: "";
          position: absolute;
          right: 2px;
          bottom: 15%;
          height: 70%;
          width: 1px;
          background: rgba(0, 0, 0, 0.1);
        }
      }
      .like-it {
        padding-right: 10px;
      }
    }

    .divider {
      width: 1px;
      height: 22px;
      background: rgba(255, 255, 255, 0.15);
    }
  }
}

.aside-bar-fixed.dark {
  box-shadow: 0px -4px 15px 0px rgba(255, 255, 255, 0.04);
  background: #1a1a1a;
  .list .aside-item .like-down::before {
    background-color: rgba(255, 255, 255, 0.15);
  }
}
.aside-bar-fixed.light {
  box-shadow: 0px -4px 15px 0px rgba(0, 0, 0, 0.03);
  background: #fff;
  .aside-left .title {
    color: #000;
    .name {
      color: #333;
    }
    .update {
      color: rgba(153, 153, 153, 1);
    }
  }

  .list {
    border-color: rgba(255, 255, 255, 0.3);

    .aside-item {
      color: #000;

      .icon {
        width: 20px;
        height: 20px;
      }
      .like-down {
        border-color: rgba(0, 0, 0, 0.1);
      }
    }

    .divider {
      background: rgba(0, 0, 0, 0.1);
    }
  }
}

.fllow-comment {
  position: absolute;
  bottom: 20px;
  right: -70px;
  display: flex;
  flex-direction: column;
  gap: 14px;

  &.light {
    .aside-item {
      color: #000;
      background: #fff;
    }
  }

  .aside-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 58px;
    height: 58px;
    color: #aab9bf;
    font-size: 12px;
    background: linear-gradient(to bottom, #2d3344, #343c45);
    border-radius: 30px;
    transition: all ease 0.3s;
    cursor: pointer;

    .wiki-icon {
      width: 20px;
      height: 20px;
    }

    i {
      font-size: 20px;
    }
  }
}

/deep/ .comment-dialog {
  margin: 5vh 0 0 0 !important;
  border-radius: 16px;
  background: linear-gradient(to bottom, #2d3344, #343c45);
  position: absolute;
  right: 10vw;

  &.light {
    margin: 5vh 0 0 0 !important;
    background: linear-gradient(to bottom, #fff, #fff);
    position: absolute;
    right: 10vw;

    .el-dialog__header {
      padding: 20px 32px 0;

      .el-dialog__title {
        color: #303133;
      }

      .el-dialog__headerbtn {
        right: 32px;
        top: 22px;

        .el-dialog__close {
          color: #303133;
        }
      }
    }

    .el-dialog__body {
      .detail-comment {
        .article-edit-container {
          background: #f5f5f5;

          .cancel-btn {
            color: #000 !important;
            background: #fff !important;
          }
        }
      }

      .content,
      .replay-content {
        color: #333333 !important;
      }

      .replay-box {
        .user-box {
          color: #8b8b8b !important;
          a {
            color: #868686 !important;
          }
          .answer {
            color: #152c66 !important;
          }
        }
      }

      .article-edit-box:empty:before {
        color: #999 !important;
      }

      .comment-to-comment {
        background: #f5f5f5;
      }
    }
  }

  .el-dialog__header {
    padding: 20px 32px 0;

    .el-dialog__title {
      color: #fff;
    }

    .el-dialog__headerbtn {
      right: 32px;
      top: 22px;

      .el-dialog__close {
        color: #fff;
      }
    }
  }

  .el-dialog__body {
    padding: 22px 32px;

    .detail-comment {
      background-color: transparent;
      padding-top: 0;
    }

    .article-edit-box {
      background-color: transparent;
      padding: 14px 10px;
    }

    .wiki-comment-list {
      background-color: transparent;
    }

    .wiki-comment-list .userAnswer {
      border-bottom: 1px solid rgba(233, 233, 233, 0.04);
      margin-right: 16px;

      .content {
        color: #bebebe;
      }

      .user-replay {
        .user-box .answer {
          color: #ceedfa;
        }

        .replay-content {
          color: #bebebe;
        }
      }
    }

    .article-edit-box {
      color: #bebebe;
      height: initial;
      max-height: 100px;
      border-radius: 4px;

      &:empty:before {
        content: attr(placeholder);
        color: #5b6478;
        font-size: 13px;
      }
    }

    .detail-comment {
      .article-edit-container {
        border: none;
        padding: 0;
        background-color: #20242e;

        .tool-bar {
          border-top: none;
          padding: 0;
          margin: 0;
          padding: 8px 10px;
          height: initial;

          .img-update-btn {
            width: initial;
          }

          .send-btn,
          .cancel-btn {
            padding: 6px 12px;
          }

          .cancel-btn {
            background-color: transparent;
            color: #fff;
          }
        }

        .img-group {
          padding: 10px;
          margin: 0;
        }
      }
    }

    .emoj-container {
      margin-bottom: 20px;
    }

    .comment-to-comment {
      background-color: #20242e;
    }

    .dialog-comment-list .wiki-detail-comment {
      height: 70vh;
      display: flex;
      flex-direction: column;
      gap: 28px;

      .detail-comment {
        background-color: transparent;
        margin: 0;
        padding: 0;
      }

      .wiki-comment-list {
        flex-grow: 1;
        height: 0;
        background-color: transparent;
        margin: 0;
        padding: 0;
      }
    }
  }
}
</style>
